import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "list-b2c-imports-page",
  class: "page list-b2c-imports-page"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { style: {"align-self":"center"} }, [
              _createElementVNode("h2", { class: "section-title" }, [
                _createElementVNode("span", null, "ALL IMPORTS")
              ])
            ], -1)
          ]))]),
          _: 1
        }),
        (!_ctx.fetchingImports || _ctx.imports)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                (_ctx.imports && _ctx.imports.length)
                  ? (_openBlock(), _createBlock(_component_AppTable, {
                      key: 0,
                      "table-data": _ctx.tableData,
                      loading: _ctx.fetchingImports,
                      disablePagination: true
                    }, null, 8, ["table-data", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.fetchingImports && !_ctx.imports)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}